export const DISTRICT_HI = {
  Balod: "बालोद",
  "Baloda Bazar": "बलौदाबाज़ार",
  Balrampur: "बलरामपुर",
  Bametara: "बेमेतरा",
  Bastar: "बस्तर",
  Bijapur: "बीजापुर",
  Bilaspur: "बिलासपुर",
  "Dakshin Bastar Dantewada": "दंतेवाड़ा",
  Dhamtari: "धमतरी",
  Durg: "दुर्ग",
  Gariaband: "गरियाबंद",
  "Janjgir Champa": "जांजगीर-चांपा",
  Jashpur: "जशपुर",
  Kabeerdham: "कबीरधाम",
  Kondagaon: "कोंडागांव",
  Korba: "कोरबा",
  Koriya: "कोरिया",
  Mahasamund: "महासमुंद",
  Mungeli: "मुंगेली",
  Narayanpur: "नारायणपुर",
  Raigarh: "रायगढ़",
  Raipur: "रायपुर",
  Rajnandgaon: "राजनांदगांव",
  Sukma: "सुकमा",
  Surajpur: "सूरजपुर",
  Surguja: "सरगुजा",
  "Uttar Bastar Kanker": "कांकेर",
};

export const districtName = (name, lang) => (lang === "hi" ? DISTRICT_HI[name] ?? name : name);
